{
  "ApiKeys_AddMode": "Prima di poter creare una chiave API, è necessario creare un utente.",
  "ApiKeys_Add_New": "Aggiungi nuova chiave API...",
  "ApiKeys_RevokeButton": "Revocare",
  "ApiKeys_RemoveButton": "Eliminare",
  "ApiKeys_TableHeader_Name": "Nome",
  "ApiKeys_TableHeader_Expiry": "Scadenza",
  "ApiKeys_TableHeader_Created": "Creato",
  "ApiKeys_TableHeader_LastAccessed": "Ultimo accesso",
  "ApiKeys_TableHeader_Title": "Chiavi API",
  "ApiKeys_Validations_Required": "Necessario",
  "ApiKeys_Name_Validations_MaxLength": "La lunghezza massima è 50",
  "ApiKeys_Revoke_ConfirmMessage": "Vuoi davvero revocare questa chiave API?",
  "ApiKeys_Revoke_Confirm": "Confermare",
  "ApiKeys_Revoke_Cancel": "Cancellare",
  "ApiKeys_Indefinite": "Mai",
  "ApiKeys_Expired": "Scaduto",
  "ApiKeys_Placeholder_Description": "Descrizione",
  "ApiKeys_KeyDisplay_Title": "Token di accesso creato: \"{}\"",
  "ApiKeys_KeyDisplay_SubTitle": "Registra questo token in un luogo sicuro, non potrà essere visualizzato o recuperato una volta chiusa questa finestra o aggiunta un'altra chiave",
  "ApiKeys_Copy_Success": "Copiato negli appunti",
  "ApiKeys_Copy_Fail": "Impossibile copiare negli appunti",
  "ApiKeys_MaxAPIKeysReached": "Hai raggiunto il numero massimo di chiavi API. Elimina una chiave esistente prima di poterne creare una nuova.",
  "NAME": "ApiKeys"
}